import styled from "styled-components";

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #f2f3f4;
  border-radius: 0.5rem;
  padding: 1rem;
  max-height: 500px;
  overflow-y: auto;
`;
BodyContent.displayName = "BodyContent";

export const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  & button {
    margin-left: 0.5rem;
  }
`;
FooterContent.displayName = "FooterContent";

export const SelectedColumnsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 50px;
`;

export const SelectedItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  margin: 2px 0;
  background: #a1c7f8ff !important;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: grab;
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #1e4b7bff !important;

  &:hover {
    background: #8bb6f0ff !important;
  }

  &.dragging {
    cursor: grabbing;
    opacity: 0.8;
  }
`;

export const DragHandle = styled.div`
  color: #1e4b7bff !important;
  margin-right: 8px;
  font-size: 14px;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #1e4b7bff !important;
  cursor: pointer;
  padding: 0;
  margin-left: 8px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;

  &:hover {
    color: #c82333 !important;
    background: #f8d7da;
  }
`;

export const AddAllLink = styled.a`
  color: #306eb1ff !important;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.9rem;
  padding-right: 1rem;

  &:hover {
    color: #022f5fff !important;
    text-decoration: none;
  }
`;
